<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button id="menu-toggle-sidebar" mat-icon-button class="navbar-toggle-button"
                *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/qualisys.svg">
                </div>
            </div>

            <div class="px-8 px-md-16" *ngIf="navigation">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
            </div>

        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">


            <div *ngIf="navigation">
                <!-- Search Parametre -->
                <parameter-search [navigation]="navigation"></parameter-search>

            </div>
            <div *ngIf="navigation" class="toolbar-separator"></div>


            <button id="userMenu" mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/profile.png">
                    <span id="username" class="username mr-12" fxHide fxShow.gt-sm>{{(authData$ |
                        async)?.username}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false" id="menu">
                <button mat-menu-item id="btn-change-pwd" (click)="notif()">
                    <mat-icon>message</mat-icon>
                    <span>{{'TOOLBAR.MSG' | translate}}</span>
                </button>
                <button mat-menu-item id="btn-change-pwd" aria-label="change password" (click)="redirect()">
                    <mat-icon>supervisor_account</mat-icon>
                    <span>{{'TOOLBAR.ACCOUNT_SETTINGS' | translate}}</span>
                </button>
                <button mat-menu-item id="btn-manage-profile" *ngIf="isAdmin" (click)="redirectToProfileForm()">
                    <mat-icon>business</mat-icon>
                    <span>{{'TOOLBAR.MANAGE_PROFILE' | translate}}</span>
                </button>

                <button mat-menu-item id="btn-logout" (click)="logout()">
                    <i class="pi pi-sign-out mr-16" style="font-size: 24px"></i>
                    <!-- <mat-icon>keyboard_return</mat-icon> -->
                    <span>{{'TOOLBAR.LOGOUT' | translate}}</span>
                </button>

            </mat-menu>

            <div class="toolbar-separator"></div>

            <notifications *ngIf="(authData$|async) && (authData$|async).userId"></notifications>



            <div class="toolbar-separator"></div>



            <!-- <fuse-search-bar (input)="search($event)"></fuse-search-bar> -->



            <button id="language-button" mat-button fxHide fxShow.gt-xs class="language-button"
                [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
                    <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                </div>
            </button>

            <mat-menu id="menu-lang" #languageMenu="matMenu" [overlapTrigger]="false">

                <button id="btn-lang" mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                        <span class="iso">{{lang.title}}</span>
                    </span>
                </button>

            </mat-menu>

            <!-- <div class="toolbar-separator" fxHide fxShow.gt-xs></div> -->

            <!-- <button mat-icon-button class="quick-panel-toggle-button" (click)="toggleSidebarOpen('quickPanel')"
                aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button> -->


            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

        </div>

    </div>

</mat-toolbar>